export const ASSET_COLORS = {
  equity: 'var(--asset-equity, #1B3668)',
  bonds: 'var(--asset-bonds, #4A6491)',
  cash: 'var(--asset-cash, #C4A052)',
  alternatives: 'var(--asset-alts, #9F8E63)',
  multi_asset: 'var(--asset-multi, #6B7280)'
} as const;

export const CATEGORY_COLORS = {
  ownership: 'var(--ownership, #2D4C7F)',
  lending: 'var(--lending, #4B6B44)',
  hybrid: 'var(--hybrid, #5E4A8E)'
} as const;

export type AssetKey = keyof typeof ASSET_COLORS;
